import {inject, Injectable} from "@angular/core";
import {EventEmitterService} from "@event-emitter";
import {SimConfigurationService, SimInjectableDataService} from "@services";
import {Location} from "@angular/common";

@Injectable({
	providedIn: "root",
})
export class EnvironmentService {
	private location = inject(Location);
	private injectableDeviceDataService = inject(SimInjectableDataService);
	private eventEmitter = inject(EventEmitterService);

	constructor() {
		this.eventEmitter.onSwitchEnvironment.subscribe((data) => {
			if (SimConfigurationService.settings.environmentOverlayEnabled) {
				const path = this.location.path();
				const [basePath, queryString] = path.split("?");
				const params = new URLSearchParams(queryString || "");

				// add current deviceId to the query parameters
				params.set("deviceId", this.injectableDeviceDataService.clientData.deviceId);
				const hash = window.location.hash; // e.g., "#section1"

				try {
					const url = new URL(`${basePath}?${params}${hash}`, data.domain);
					window.location.href = url.href;
				} catch (e) {
					console.error("Failed to parse the URL for environment switch.", e);
				}
			}
		});
	}

	public handleEnvironmentDeviceIdChanges() {
		if (SimConfigurationService.settings.environmentOverlayEnabled) {
			// we have to use location here because route is not available in the app initializer
			const path = this.location.path();
			const [basePath, queryString] = path.split("?");
			if (queryString) {
				const params = new URLSearchParams(queryString);
				const deviceIdNew = params.get("deviceId");
				const deviceIdCurrent = this.injectableDeviceDataService.clientData.deviceId;
				if (!!deviceIdNew) {
					if (deviceIdNew !== deviceIdCurrent) {
						console.debug(`Device id changed from ${deviceIdCurrent} to ${deviceIdNew}`);
						this.injectableDeviceDataService.setDeviceId(deviceIdNew);
					}

					params.delete("deviceId");
					// Replace the current history state with the cleaned URL
					this.location.replaceState(basePath, params.toString());
				}
			}
		}
	}
}
